import { Injectable } from '@angular/core';
import { Company } from '@rtls/core/models/location/company.model';
import { Result } from '@rtls/core/models/result.model';
import { Pagination } from '@rtls/core/models/rpc/pagination.model';
import { SearchOperation } from '@rtls/core/models/rpc/search-operation';
import { SearchQuery } from '@rtls/core/models/rpc/search-query';
import { RtlsModels } from '@rtls/core/models/rtls/rtls-models';
import { RtlsServiceDecorator } from '@rtls/core/models/rtls/rtls-service.decorator';
import { RtlsService } from '@rtls/core/models/rtls/rtls-service.model';
import { Observable } from 'rxjs';

@Injectable()
export class CompanyService extends RtlsServiceDecorator<Company> {
	constructor(rtlsService: RtlsService<Company>) {
		super(rtlsService.useModel(RtlsModels.Company));
	}

	public prebuiltSearch(
		searchTerms: string,
		pagination: Pagination = Pagination.unlimited(),
	): Observable<Result<Company>> {
		return this.search(new SearchQuery('corporateName', SearchOperation.CONTAINS, searchTerms), pagination, true);
	}

	public batchAdd(companies: Company[]) {
		return this.saveBatch(companies);
	}
}
